module.exports = __webpack_public_path__ + "static/media/nfe_mapa.062a51ea.png";